module.exports = __webpack_public_path__ + "img/OnSite.ee4228cd.png";